import React ,{useState}from "react";
import { Template1AssetHeader } from "../Template1AssetHeader";
import { Template1Footer } from "../Template1Footer";
import { Template1DocumentContent } from "./Template1DocumentContent";
import { Template1Header } from "../Template1Header";
import { Template1AssetFooter } from "../Template1AssetFooter";

export const Template1Document = ({ data, setFeatures, settings, goBack }) => {
 
const [isDownloadBtnClicked,setIsDownloadBtnClicked]=useState(false);

const isDownloadBtnClickedFn=()=>{
  setIsDownloadBtnClicked(isDownloadBtnClicked===true?false:true)
}
  return (
    <>
      <div className="page">
        <Template1AssetHeader
          logoURL={data?.logo}
          setFeatures={setFeatures}
          settings={settings}   
          goBack={goBack}
          data={data}
          isDownloadBtnClickedFn={isDownloadBtnClickedFn}
        />
        <Template1DocumentContent
          title={data?.asset_details.title}
          description={data?.asset_details.description}
          sourceURL={data?.asset_details.source_url}
          allowDownload={data?.settings?.allowDownload}
          isCaptureLeadBeforeDownloadingTheAsset={data?.settings?.isCaptureLeadBeforeDownloadingTheAsset}
          data={data?.exhibitor_id}
          isDownloadBtnClickedProps={isDownloadBtnClicked}
        />
   <Template1AssetFooter settings={settings}/>
      </div>
    </>
  );
};
